import { router } from "@inertiajs/react";
import { Divider, Flex } from "@mantine/core";
import { DocumentCard } from "../../components/card/DocumentCard";
import { openFile } from "../../helpers/fileHelper";
import { getFullName } from "../../helpers/stringHelper";
import { ContentShell } from "../../layout/ContentShell";
import type { Apprentice } from "../../models/apprentice";
import type { Document } from "../../models/document";
import { public_document_views_path, public_documents_path } from "../../routes";
import { openSignModal } from "../users/apprentice/ApprenticeDocuments";

type DocumentViewProps = {
  token: string;
  document: Document;
  apprentice: Apprentice;
};

export default function DocumentView({ document, token, apprentice }: DocumentViewProps) {
  const onDocumentClick = () => {
    createDocumentView();
    openFile(public_documents_path(), [{ key: "token", value: token }]);
  };

  const openModal = (document: Document) => openSignModal(document, () => createDocumentView(true));

  const createDocumentView = (signed = false) => {
    router.post(public_document_views_path(), { token, signed });
  };

  return (
    <ContentShell title={`Dokument für ${getFullName(apprentice)}`}>
      <Divider size="sm" />
      <Flex justify="center" w="100%">
        <DocumentCard
          shadow="xs"
          padding="lg"
          withBorder
          w={{ base: "20rem", md: "30rem", sm: "25rem", xs: "20rem" }}
          onOpen={onDocumentClick}
          document={document}
          onSign={document.signable ? () => openModal(document) : undefined}
        />
      </Flex>
    </ContentShell>
  );
}
